import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';

import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';

// Initialize Crisp chat widget
if (import.meta.env.PROD) {
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = '66ee2ea7-b094-486b-9041-a04ebcab9e5f';
  const s = document.createElement('script');
  s.src = 'https://client.crisp.chat/l.js';
  s.async = 1;
  document.head.appendChild(s);
}

// Initialize Sentry error tracking
if (import.meta.env.VITE_SENTRY_DSN_FRONTEND) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_FRONTEND,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff'
          },
          success: {
            iconTheme: {
              primary: '#22c55e',
              secondary: '#fff'
            }
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff'
            }
          }
        }}
        />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
